import { GroupInsurancePageTemplate } from "./template";

export const GroupInsurancePage = (): JSX.Element => {
  return <GroupInsurancePageTemplate />;
};
